<fieldset>
  <legend>2-Factor Authenticatie code</legend>
  <p class="pin-helptext" id="otp-helptext">
    Voer de 6-cijferige code in die in de Authenticator-app getoond wordt.
  </p>
  <div data-cy="pin-wrapper" class="pin-wrapper" [class.pin-wrapper--code-hidden]="isCodeHidden">
    @for (field of digits.controls; track i; let i = $index) {
      <input
        #inputs
        type="tel"
        class="pin-input"
        aria-describedby="otp-helptext"
        [maxLength]="1"
        [formControl]="field"
        (paste)="onPaste($event)"
        (keydown.backspace)="backspace(i, $event)"
      />
    }
  </div>
</fieldset>
